import { render } from "./PpcBidOptimizer.vue?vue&type=template&id=ac62fa4a&scoped=true"
import script from "./PpcBidOptimizer.vue?vue&type=script&lang=js"
export * from "./PpcBidOptimizer.vue?vue&type=script&lang=js"

import "./PpcBidOptimizer.vue?vue&type=style&index=0&id=ac62fa4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac62fa4a"]])

export default __exports__